import React from "react"
import {useTranslation} from "react-i18next"

import {useReportsOpportunitiesChartQuery} from "../../../../queries/reports"
import {SimpleBarGraphCard} from "./SimpleBarGraphCard"

export const OpportunitiesGraphCard: React.FC = () => {
  const {t} = useTranslation()

  return (
    <SimpleBarGraphCard
      metric={"opportunities"}
      query={useReportsOpportunitiesChartQuery}
      config={[
        {
          key: "proposal_sent",
          label: t("Reports_Chart_Opportunities_ProposalSent"),
          color: "var(--color-cr-blue)",
        },
        {
          key: "future_deals",
          label: t("Reports_Chart_Opportunities_FutureDeals"),
          color: "var(--color-cr-cyan)",
        },
        {
          key: "negotiating",
          label: t("Reports_Chart_Opportunities_Negotiating"),
          color: "var(--color-cr-blue-mid)",
        },
      ]}
    />
  )
}
